import { FileCheck2, Award, MessageCircle, MapPin, ShieldCheck, Gem } from "lucide-react";

// ─────────────────────────────────────────────────────────────
// CONTACTO / WHATSAPP
// ─────────────────────────────────────────────────────────────
export const PHONE = "689 634 999";
export const PHONE_TEL = "689634999";
export const EMAIL = "hondallopezivan@gmail.com";
export const WHATSAPP_NUMBER = "34628328285"; // 628 328 285
export const WHATSAPP_DISPLAY = "628 328 285";

export const HORARIO = [
  ["Lunes – Jueves", "08:00 – 19:00"],
  ["Viernes", "08:00 – 18:00"],
  ["Sábado", "09:00 – 14:00"],
  ["Domingo", "Cerrado"],
];

export const RATING_AVG = "5,0";

// Preguntas frecuentes
export const FAQS = [
  { q: "¿El presupuesto es gratis?", a: "Sí. Elaboramos tu presupuesto de forma gratuita y sin compromiso, con visita y medición a domicilio en toda Cantabria." },
  { q: "¿PVC o aluminio, cuál me conviene?", a: "Depende del aislamiento que busques, el uso y el presupuesto. Te asesoramos sin compromiso para que elijas la mejor opción para tu hogar." },
  { q: "¿Puedo pasar mi ventana a oscilobatiente sin cambiarla entera?", a: "Sí. Convertimos ventanas convencionales en oscilobatientes sin sustituir toda la carpintería: una solución cómoda, económica y muy demandada." },
  { q: "¿Cuánto tardáis en hacer el trabajo?", a: "Depende de cada proyecto y de la fabricación a medida. Te damos un plazo estimado junto con el presupuesto." },
  { q: "¿Los trabajos tienen garantía?", a: "Sí, ofrecemos garantía en todos nuestros trabajos y utilizamos materiales de primera calidad." },
  { q: "¿Hacéis mosquiteras a medida?", a: "Sí, fabricamos e instalamos mosquiteras a medida (enrollables, correderas y fijas) para que disfrutes de tu hogar sin insectos." },
];

// Redes sociales — pon aquí tus URLs (deja "" para ocultar el icono).
export const SOCIAL = {
  instagram: "https://www.instagram.com/ivanhondallopez",
  facebook: "https://www.facebook.com/share/1J3mzny8Cv/",
};

// Cómo trabajamos
export const STEPS = [
  { n: "01", title: "Contacto", text: "Cuéntanos qué necesitas por WhatsApp, teléfono o con el formulario. Sin compromiso." },
  { n: "02", title: "Visita y medición", text: "Nos desplazamos a tu domicilio en Cantabria y tomamos medidas exactas de cada hueco." },
  { n: "03", title: "Presupuesto claro", text: "Te enviamos un presupuesto detallado, gratuito y sin sorpresas ni letra pequeña." },
  { n: "04", title: "Montaje y garantía", text: "Instalamos con acabados de calidad, limpieza y garantía en todos los trabajos." },
];

export const waUrl = (msg = "Hola Ventanas Hondal, me gustaría pedir un presupuesto gratuito y sin compromiso.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

// Enlace a tu perfil de Google (reseñas reales).
export const GOOGLE_REVIEWS_URL = "https://share.google/hImOKPOHEcyw9d9b9";

// ─────────────────────────────────────────────────────────────
// IMÁGENES  → deja src vacío ("") para mostrar un espacio preparado.
// Cuando tengas la foto real, pega su URL (o /ruta) en src y aparecerá.
// ─────────────────────────────────────────────────────────────
export const HERO_IMAGE = ""; // "" = fondo de marca. Pon una foto real de un trabajo para usarla de fondo.
export const ABOUT_IMAGE = ""; // Foto de Iván trabajando / taller.
export const VAN_IMAGE = "https://static.prod-images.emergentagent.com/jobs/bf5e995a-5484-4c7b-bc54-d51a23871d1d/images/9e0880d21b097757d855dcd4fd65c9c1c0a125a91a61534656be348ab71a159e.jpeg";

export const GALLERY = [
  { src: "https://static.prod-images.emergentagent.com/jobs/bf5e995a-5484-4c7b-bc54-d51a23871d1d/images/b3014325074942de2a30531e64396ea08110d0ee5ebca13fb937d1ab4a3dbe5c.jpeg", label: "Cubierta acristalada de piscina", span: "lg:col-span-8 lg:row-span-2" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_citas-portfolio/artifacts/ln88nqsm_IMG-20260608-WA0038.jpg", label: "Montaje de gran cerramiento acristalado", span: "lg:col-span-4 lg:row-span-1" },
  { src: "https://static.prod-images.emergentagent.com/jobs/bf5e995a-5484-4c7b-bc54-d51a23871d1d/images/b3caa99945e5d08a440fbc3f645c8c20b8d4d9cb1a1b271944603cb5695c3976.jpeg", label: "Ventana con mosquitera a medida", span: "lg:col-span-4 lg:row-span-1" },
  { src: "https://static.prod-images.emergentagent.com/jobs/bf5e995a-5484-4c7b-bc54-d51a23871d1d/images/05f30f6c834a24b30c72fdd92e6ab16375c2f4dc4ab15c0ec294c24e050831d5.jpeg", label: "Corredera de aluminio con mosquitera plisada", span: "lg:col-span-4 lg:row-span-2" },
  { src: "https://static.prod-images.emergentagent.com/jobs/bf5e995a-5484-4c7b-bc54-d51a23871d1d/images/08561783f08bc1c0a1c757ced6f6a6894ba83f6c53821dae40fc006dbca28b7d.jpeg", label: "Cerramiento de porche en aluminio", span: "lg:col-span-8 lg:row-span-1" },
  { src: "https://images.unsplash.com/photo-1686916057395-7277599ac1c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Estores", span: "lg:col-span-4 lg:row-span-1" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_citas-portfolio/artifacts/wa7vvuqi_Screenshot_20260729_032229_Instagram.jpg", label: "Puerta acristalada imitación madera", span: "lg:col-span-4 lg:row-span-1" },
];

// ─────────────────────────────────────────────────────────────
// SERVICIOS  (SEO: PVC/aluminio Cantabria, oscilobatiente, mosquiteras...)
// ─────────────────────────────────────────────────────────────
export const SERVICES = [
  {
    n: "01",
    featured: true,
    title: "Conversión a oscilobatiente",
    desc: "Convertimos ventanas convencionales en ventanas oscilobatientes sin necesidad de sustituir toda la carpintería. Una solución cómoda, económica y muy demandada que mejora la ventilación, la seguridad y el confort del hogar.",
  },
  { n: "02", featured: true, title: "Cerramientos de PVC y aluminio", desc: "Montaje de cerramientos de PVC y cerramientos de aluminio con acabados de calidad, cuidando cada detalle y cada junta." },
  { n: "03", title: "Mosquiteras a medida", desc: "Mosquiteras a medida para disfrutar de tu hogar con las ventanas abiertas y sin insectos. Enrollables, correderas y fijas." },
  { n: "04", title: "Persianas", desc: "Instalación y sustitución de persianas manuales y motorizadas para máximo confort y aislamiento." },
  { n: "05", title: "Estores", desc: "Estores enrollables y a medida para controlar la luz y vestir tus ventanas con estilo." },
  { n: "06", title: "Cerrajería", desc: "Colocaciones técnicas y soluciones de cerrajería con garantía y seguridad." },
  { n: "07", title: "Reparación de ventanas", desc: "Reparación de ventanas de PVC y aluminio: ajustes, cambio de herrajes y sellados que duran." },
  { n: "08", title: "Puertas de PVC y aluminio", desc: "Instalación de puertas de PVC y aluminio, de entrada y correderas, con aislamiento térmico y acústico superior." },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);

export const MANIFESTO = [
  { n: "01", title: "Medimos la luz", text: "Cada hueco es único. Tomamos medidas con precisión milimétrica para que el marco encaje como una pieza de relojería." },
  { n: "02", title: "Cuidamos el detalle", text: "El acabado importa. Juntas limpias, sellados perfectos y un montaje del que nos sentimos orgullosos." },
  { n: "03", title: "Aislamos tu hogar", text: "PVC y aluminio de alto rendimiento térmico y acústico. Menos ruido, menos consumo, más confort." },
];

// ─────────────────────────────────────────────────────────────
// VENTAJAS
// ─────────────────────────────────────────────────────────────
export const ADVANTAGES = [
  { icon: FileCheck2, title: "Presupuesto gratuito", text: "Sin compromiso y con asesoramiento honesto." },
  { icon: Award, title: "+20 años de experiencia", text: "Oficio y trabajos bien hechos que duran." },
  { icon: MessageCircle, title: "Atención rápida por WhatsApp", text: "Te respondemos en el mismo día." },
  { icon: MapPin, title: "Trabajamos en toda Cantabria", text: "Desplazamiento por toda la comunidad." },
  { icon: Gem, title: "Materiales de primera calidad", text: "PVC y aluminio de primeras marcas." },
  { icon: ShieldCheck, title: "Garantía en todos los trabajos", text: "Respaldamos cada instalación." },
];

// ─────────────────────────────────────────────────────────────
// RESEÑAS  → sustituye estos textos por tus reseñas reales de Google.
// Formato: { name, rating (1-5), text, source }
// ─────────────────────────────────────────────────────────────
export const REVIEWS = [
  { name: "Mónica", rating: 5, when: "Hace un mes", text: "Muy profesional, rápido, trabajo limpio. Encantada, le recomiendo.", source: "Google" },
  { name: "Montse", rating: 5, when: "Hace 2 meses", text: "Me arregló una ventana y me puso unas mosquiteras y sin duda le volveré a llamar. Además es un encanto: serio, educado y muy trabajador.", source: "Google" },
  { name: "Ángel Luis", rating: 5, when: "Hace 2 meses", text: "Un profesional tanto en mano de obra como en materiales. Se ciñe bien a la cartera del cliente, muy serio. Mi carpintero de confianza.", source: "Google" },
  { name: "Alberto", rating: 5, when: "Hace 2 meses", text: "Cerramiento perfecto, muchísima calidad de materiales y trabajo súper bien rematado.", source: "Google" },
  { name: "Agustín", rating: 5, when: "Hace 2 meses", text: "Muy buen profesional, trabajador top.", source: "Google" },
  { name: "Carmen", rating: 5, when: "Hace un mes", text: "Profesional, puedes confiar en él.", source: "Google" },
  { name: "Antonio", rating: 5, when: "Hace 2 meses", text: "Trabajo top.", source: "Google" },
  { name: "Iván", rating: 5, when: "Hace 2 meses", text: "Gran profesional.", source: "Google" },
];
